export enum SubscriptionState {
  ACTIVE = 0,
  PAUSED = 1,
  DEACTIVATED = 2,
  CANCELLATION_REQUESTED = 3,
  CANCELLED = 4,
  REFUNDED = 5,
  TRIALING = 6,
  CREATED = 7,
}

export default { SubscriptionState };
